import {createSelector} from 'reselect';

// NOTE: These selectors, unlike those in resources/selectors.js, operate on the entire
//       Redux store. This is because they're used across different sections of the app.


// helpers

const propertySelector = key => object => object[key];

const viewOptionsSelector = propertySelector('viewOptions');

const sortOptionsSelector = viewOptions => viewOptions.sortOptions;
const sortsSelector = sortOptions => sortOptions.sorts;

const filterOptionsSelector = viewOptions => viewOptions.filterOptions;
const namedFiltersSelector = filterOptions => filterOptions.namedFilters;
const rawFiltersSelector = filterOptions => filterOptions.filters;


// viewOptions.resources selectors

const resourcesSelector = createSelector(
  viewOptionsSelector,
  propertySelector('resources')
);

// selects {sortOptions, filterOptions} from viewOptions.resources[resourceType]
export const createResourceViewOptionsSelector = resourceType => createSelector(
  resourcesSelector,
  propertySelector(resourceType)
);

// selects 'sortOptions' from viewOptions.resources[resourceType]
export const createResourceSortOptionsSelector = resourceType => createSelector(
  createResourceViewOptionsSelector(resourceType),
  sortOptionsSelector
);

// selects 'sorts' from viewOptions.resources[resourceType].sortOptions
export const createResourceSortsSelector = resourceType => createSelector(
  createResourceSortOptionsSelector(resourceType),
  sortsSelector
);

// selects 'filterOptions' from viewOptions.resources[resourceType]
export const createResourceFilterOptionsSelector = resourceType => createSelector(
  createResourceViewOptionsSelector(resourceType),
  filterOptionsSelector
);

// selects 'namedFilters' from viewOptions.resources[resourceType].filterOptions
export const createResourceNamedFiltersSelector = resourceType => createSelector(
  createResourceFilterOptionsSelector(resourceType),
  namedFiltersSelector
);

// selects 'filters' from viewOptions.resources[resourceType].filterOptions
export const createResourceRawFiltersSelector = resourceType => createSelector(
  createResourceFilterOptionsSelector(resourceType),
  rawFiltersSelector
);



// WEBPACK FOOTER //
// ./public/viewOptions/selectors.js